// extracted by mini-css-extract-plugin
export default {"Toggle":"Toggle--KkpGU","Toggle_State_Off":"Toggle_State_Off--rf8fi","Toggle__Thumb":"Toggle__Thumb--BEarv","Toggle_State_On":"Toggle_State_On--PPQwu"};